window.addEventListener('load', function () {
    if (document.querySelectorAll('.articleSlider').length) {
        const elements = document.querySelectorAll('.articleSlider');

        elements.forEach(function (element) {
            let articleSlider = new Swiper(element.querySelector('.swiper'), {
                watchOverflow: true,
                lazy: true,
                preloadImages: false,
                loadPrevNext: true,
                checkInView: true,
                slidesPerView: 1,
                spaceBetween: 20,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    600: {
                        slidesPerView: 1,
                        spaceBetween: 30,
                    },
                    660: {
                        slidesPerView: 2,
                        spaceBetween: 30,
                    },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                    1400: {
                        slidesPerView: 3,
                        spaceBetween: 80,
                    },
                    1600: {
                        slidesPerView: 3,
                        spaceBetween: 130,
                    },
                    1910: {
                        slidesPerView: 3,
                        spaceBetween: 160,
                    },
                },
                navigation: {
                    nextEl: element.querySelector('.swiper-button-next'),
                    prevEl: element.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: element.querySelector('.swiper-pagination'),
                },
            });
        });
    }
});
